// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_router__CabinetRoute from "./CabinetRoute.js";
import * as Buhta_router__LandingRoute from "./LandingRoute.js";
import * as Stdlib__List from "melange/list.js";

function getRouterUrl(uri) {
  const uriList = Belt__Belt_List.fromArray(uri.split("?", undefined));
  const path = Belt__Belt_List.fromArray(Belt__Belt_List.getExn(uriList, 0).substring(1, undefined).split("/", undefined));
  const __x = Belt__Belt_List.get(uriList, 1);
  const search = Belt__Belt_Option.mapWithDefault(__x, "", (function (value) {
    return value;
  }));
  return {
    path: path,
    hash: "",
    search: search
  };
}

function prepareServerUrl(serverUrl) {
  return Belt__Belt_Option.mapWithDefault(serverUrl, undefined, (function (url) {
    return getRouterUrl(url);
  }));
}

function isProtected(url) {
  return Buhta_router__CabinetRoute.isProtected(Buhta_router__CabinetRoute.ofUrl(url));
}

function urlWithParams(url, params) {
  if (Stdlib__List.length(params) <= 0) {
    return url;
  }
  const params$1 = Belt__Belt_List.toArray(Belt__Belt_List.map(params, (function (param) {
    return param[0] + ("=" + param[1]);
  }))).join("&");
  return url + ("?" + params$1);
}

function getCountry(url) {
  const route = Buhta_router__LandingRoute.ofUrl(url);
  if (/* tag */ typeof route === "number" || typeof route === "string" || route.TAG !== /* Landing */ 0) {
    return /* COUNTRY_KAZ */ 1;
  } else {
    return route._0;
  }
}

function getLanguage(url) {
  const route = Buhta_router__LandingRoute.ofUrl(url);
  if (/* tag */ typeof route === "number" || typeof route === "string" || route.TAG !== /* Landing */ 0) {
    return /* Ru */ 1;
  } else {
    return route._1;
  }
}

function isNotFound(url) {
  const routeLanding = Buhta_router__LandingRoute.ofUrl(url);
  const routeCabinet = Buhta_router__CabinetRoute.ofUrl(url);
  if (routeLanding === /* NotFound */ 0) {
    return routeCabinet === /* NotFound */ 2;
  } else {
    return false;
  }
}

function isLanding(url) {
  const route = Buhta_router__CabinetRoute.ofUrl(url);
  return route === /* NotFound */ 2;
}

function isApp(url) {
  const route = Buhta_router__LandingRoute.ofUrl(url);
  return route === /* App */ 1;
}

export {
  getRouterUrl,
  prepareServerUrl,
  isProtected,
  urlWithParams,
  getCountry,
  getLanguage,
  isNotFound,
  isLanding,
  isApp,
}
/* Buhta_router__CabinetRoute Not a pure module */
